import {
  Box,
  Button,
  Tooltip,
  Typography
} from "@dealer-center/core-components";
import { SR_ONLY_SX } from "./srOnlySx";

// Exported so specs assert the real copy instead of a duplicate that drifts.
export const CREATE_NOT_ALLOWED_REASON =
  "Your role does not allow creating records. Ask an NRT administrator for access.";

export interface HeaderProps {
  canCreate: boolean;
  subtitle: string;
  title: string;
  onAddNewRecord: () => void;
}

export const Header = ({
  canCreate,
  subtitle,
  title,
  onAddNewRecord
}: HeaderProps) => {
  const addNewRecordButton = (
    <Button
      analyticsConfiguration={{ eventName: "nrt_mapping_tool_add_record" }}
      buttonStyle="primary"
      disabled={!canCreate}
      onClick={onAddNewRecord}
    >
      Add New Record
    </Button>
  );

  return (
    <Box
      sx={{
        alignItems: { md: "center", xs: "flex-start" },
        display: "flex",
        flexDirection: { md: "row", xs: "column" },
        gap: 2,
        justifyContent: "space-between"
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography variant="h1">{title}</Typography>
        <Typography variant="body-md">{subtitle}</Typography>
      </Box>
      {canCreate ? (
        addNewRecordButton
      ) : (
        <Box sx={{ alignItems: "center", display: "flex" }}>
          <Tooltip
            position="left"
            size="large"
            toolTipContent={CREATE_NOT_ALLOWED_REASON}
          >
            {/* A disabled button receives no pointer events, so the tooltip
                hangs off this wrapper rather than the button itself. */}
            <Box
              data-testid="nrt-add-record-tooltip-target"
              sx={{ display: "inline-flex" }}
            >
              {addNewRecordButton}
            </Box>
          </Tooltip>
          {/* The disabled button isn't focusable, so this carries the same
              sentence in document order for keyboard/screen-reader users. */}
          <Typography sx={SR_ONLY_SX} variant="body-md">
            {CREATE_NOT_ALLOWED_REASON}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
